module.exports = __webpack_public_path__ + "img/Weapon_83.3bc9d2aa.png";